import React from 'react';

export const reviewPageTitle =
  'You’ve finished providing information about your mental health conditions';

export const reviewPageDescription = (
  <>
    <p>
      The information you’ve provided in this section will be available for you
      to review before you submit your claim.
    </p>
    <p>In the next step you’ll be able to:</p>
    <ul>
      <li>
        <strong>Upload or request records from medical providers</strong> you
        received treatment from for VA to review, including those who treated
        you for your mental health conditions
      </li>
      <li>
        <strong>Upload any supporting documents about your conditions</strong>,
        including those relating to mental health
      </li>
    </ul>
    <p>
      We understand that some questions may have been difficult to answer. All
      the information you’ve provided so far has been saved. You can take a
      break and return to continue your claim later if you want.
    </p>
  </>
);
